<template>
  <div>
    <div id="pl_ts-footer" class="mx-auto"></div>
    <script2>
      _tsRatingConfig = {
      tsid: 'XC513E98EB1F05BB5183FD80883A561F8',
      variant: 'testimonial',
      reviews: '5',
      betterThan: '4.5',
      richSnippets: 'on',
      backgroundColor: '#ffdc0f',
      linkColor: '#000000',
      fontFamily: 'Verdana',
      fontColor: '#000000',
      reviewMinLength: '12',
      quotationMarkColor: '#ffffff',
      responsive: { variant: 'floating' }
      };

      var scripts = document.getElementsByTagName('SCRIPT'),
      //me = scripts[scripts.length - 1];
      mee = document.getElementById('pl_ts-footer');
      var _ts = document.createElement('SCRIPT');
      _ts.type = 'text/javascript';
      _ts.async = true;
      _ts.src = '//widgets.trustedshops.com/reviews/tsSticker/tsSticker.js';
      //me.parentNode.insertBefore(_ts, me);
      mee.insertBefore(_ts, mee.childNodes[0]);
      _tsRatingConfig.script = _ts;
    </script2>
  </div>
</template>

<script>
export default {
  name: "ts-ratings"
};
</script>
